// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"6fc19dcd","749":"26064be3","903":"3a9d2b53"}[chunkId] + ".chunk.js";
};